import React, { useState, useEffect, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHistory, faUpload, faComments, faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Button } from 'reactstrap';
import { get } from 'helpers/requests';
import { BASE_URL, API } from 'CONST';
import Icon from 'components/UI/Icon';
import InfoPill from 'components/shared/InfoPill';
import '../../../styles/deudor.css';

import { getIconInfo } from '../../../helpers/helpersRatingInfo';

import RepositoryModal from './posicionDeudorRepositorio'
import BalanceCreditoContext from './balanceCreditoContext';
import ComentariosMovimientoModal from './comentariosMovimientoModal';
import EstadosDeudorHistorialModal from './estadosDeudorHistorialModal';


const PosicionDeudorInternalInfo = ({ datos, modalCerrado, deudorIsForeign }) => {
  const { balanceCreditoData } = useContext(BalanceCreditoContext);
  const [isModalRepositorio, setIsModalRepositorio] = useState(false);
  const [isModalComentarios, setIsModalComentarios] = useState(false);
  const [isModalHistorial, setIsModalHistorial] = useState(false);
  const [otrosDocumentos, setOtrosDocumentos] = useState([]);

  const estados = {
    vigente: 'Vigente',
    bloqueado: 'Lista Negra',
  };
  
  const toggleModalHistorial = () => {
    setIsModalHistorial(!isModalHistorial);
  };

  const fetchOtrosDocumentos = () => {
    if (!datos.id) return;
    
    get(`${BASE_URL}${API.documentosdeudordirect}/?deudor_id=${datos.id}`)
      .then((response) => {
        if (response && response.length > 0) {
          setOtrosDocumentos(response);
        } else {
          setOtrosDocumentos([]);
        }
      })
      .catch((error) => {
        console.error('Error al obtener documentos del deudor:', error);
      });
  };

  const isWithinLastWeek = (date) => {
    if (!date) return false;
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
    const documentDate = new Date(date);
    return documentDate >= oneWeekAgo;
  };

  const hasRecentDocuments = useMemo(() => {
    const hasRecentMovementDocs = balanceCreditoData?.data?.some(item => {
      const hasMovementDocs = item.documentos_ids?.length > 0;
      const hasCarpeta = item.carpeta_tributaria_id;
      const isRecent = isWithinLastWeek(item.fecha_solicitud);
      return (hasMovementDocs || hasCarpeta) && isRecent;
    });

    // Check otros documentos
    const hasRecentOtrosDocs = otrosDocumentos.some(doc => 
      isWithinLastWeek(doc.upload_date)
    );

    return hasRecentMovementDocs || hasRecentOtrosDocs;
  }, [balanceCreditoData, otrosDocumentos]);

  useEffect(() => {
    fetchOtrosDocumentos();
  }, [datos]);

  useEffect(() => {
    if (modalCerrado) {
      fetchOtrosDocumentos();
    }
  }, [modalCerrado]);


  const toggleModalRepositorio = () => {
    setIsModalRepositorio(!isModalRepositorio);
  };

  const toggleModalComentarios = () => {
    setIsModalComentarios(!isModalComentarios);
  };
  
  const colXsSize = deudorIsForeign ? 4 : 3;

  return (
    <>
      {/* First Row - Main Info Pills */}
      <Row className="mt-3">
        <Col xs={colXsSize}>
          <InfoPill
            label="Estado Deudor"
            value={(
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span>{datos.estado ? estados[datos.estado] : '---'}</span>
                <Button
                  title="Ver historial de estados"
                  style={{
                    background: 'transparent',
                    border: 'none',
                    color: 'white',
                    padding: '0',
                    fontSize: '14px',
                    cursor: 'pointer',
                  }}
                  onClick={toggleModalHistorial}
                >
                  <FontAwesomeIcon icon={faHistory} />
                </Button>
              </div>
            )}
            backgroundColor="var(--custom-light-blue)"
            color="white"
          />
        </Col>
        {!deudorIsForeign && (
          <Col xs={3}>
            <InfoPill
              label="Score Motor"
              value={datos.score}
            />
          </Col>
        )}
        <Col xs={colXsSize}>
          <InfoPill
            label="Comentarios"
            value={(
              <Button
                title="Ver Comentarios por Movimiento"
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: 'currentcolor',
                }}
                onClick={toggleModalComentarios}
              >
                <div className="icon-wrapper">
                  <Icon id="comentarios-movimiento" tooltipText="Ver Comentarios">
                    <FontAwesomeIcon icon={faComments} style={{ fontSize: '15px', color: 'white' }} />
                  </Icon>
                </div>
              </Button>
            )}
            backgroundColor="var(--orsan-blue-s3)"
            color="#A4BBD3"
            style={{ fontSize: '0.88rem' }}
          />

          <ComentariosMovimientoModal 
            isOpen={isModalComentarios} 
            toggle={toggleModalComentarios} 
            dataCredito={balanceCreditoData}
            dataDeudor={datos}
          />
        </Col>

        <Col xs={colXsSize}>
          <InfoPill
            label="Repositorio"
            value={(
              <div style={{ position: 'relative', display: 'inline-block' }}>
                <Button
                  title="Repositorio"
                  style={{
                    background: 'transparent',
                    border: 'none',
                    color: 'currentcolor',
                  }}
                  onClick={toggleModalRepositorio}
                >
                  <div className="icon-wrapper">
                    <Icon id="repositorio" tooltipText="Abrir">
                      <FontAwesomeIcon icon={faUpload} style={{ fontSize: '15px', color: 'white' }} />
                    </Icon>
                  </div>
                </Button>
                {hasRecentDocuments && (
                  <span 
                    style={{
                      position: 'absolute',
                      top: '-5px',
                      right: '-5px',
                      background: '#ff4444',
                      color: 'white',
                      borderRadius: '50%',
                      width: '18px',
                      height: '18px',
                      fontSize: '10px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 'bold'
                    }}
                    title="Documentos recientes disponibles"
                  >
                    <FontAwesomeIcon icon={faPaperclip} />
                  </span>
                )}
              </div>
            )}
            backgroundColor="var(--orsan-blue-s3)"
            color="#A4BBD3"
          />
          <RepositoryModal 
            isOpen={isModalRepositorio} 
            toggle={toggleModalRepositorio} 
            dataCredito={balanceCreditoData}
            dataDeudor={datos}
            otrosDocumentos={otrosDocumentos}
          />
        </Col>
      </Row>
      <EstadosDeudorHistorialModal 
        isOpen={isModalHistorial}
        toggle={toggleModalHistorial}
        deudorId={datos.id}
      />
    </>
  );
};

PosicionDeudorInternalInfo.propTypes = {
  datos: PropTypes.shape({
    id: PropTypes.number,
    rut: PropTypes.string,
    name: PropTypes.string,
    estado: PropTypes.string,
    inicio_actividad: PropTypes.string,
    actividad: PropTypes.arrayOf(PropTypes.object),
    rubro_id: PropTypes.number,
    tamano: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    contacto: PropTypes.string,
    score: PropTypes.number,
    deudorIsForeign: PropTypes.bool,
  }).isRequired,
  modalCerrado: PropTypes.bool,
  deudorIsForeign: PropTypes.bool,
};
PosicionDeudorInternalInfo.defaultProps = {
  modalCerrado: false,
  deudorIsForeign: false,
};
export default PosicionDeudorInternalInfo;
